import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallActionComponent } from './call-action/call-action.component';
import { EmailActionComponent } from './email-action/email-action.component';
import { WebsiteActionComponent } from './website-action/website-action.component';
import { LabelValueComponent } from './label-value/label-value.component';
import { DownloadFileActionComponent } from './download-file-action/download-file-action.component';
import { PersonalEvidencingDocumentsComponent } from './personal-evidencing-documents/personal-evidencing-documents.component';
import { RelationWithBankComponent } from './relation-with-bank/relation-with-bank.component';
import { ShareHoldersComponent } from './share-holders/share-holders.component';
import { ViewLinkActionComponent } from './view-link-action/view-link-action.component';
import {FileNamePipeModule} from "../pipes/file-name-pipe/file-name-pipe.module";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";


@NgModule({
  declarations: [
    CallActionComponent,
    EmailActionComponent,
    WebsiteActionComponent,
    LabelValueComponent,
    DownloadFileActionComponent,
    PersonalEvidencingDocumentsComponent,
    RelationWithBankComponent,
    ShareHoldersComponent,
    ViewLinkActionComponent

  ],
    imports: [CommonModule, FileNamePipeModule, TranslateModule, RouterModule],
  exports: [
    CallActionComponent,
    EmailActionComponent,
    WebsiteActionComponent,
    LabelValueComponent,
    DownloadFileActionComponent,
    PersonalEvidencingDocumentsComponent,
    RelationWithBankComponent,
    ShareHoldersComponent,
    ViewLinkActionComponent
  ]
})
export class SharedActionsModule { }
